<template>
  <!--
    فیلترهای اختصاصی ترافیک — مکمل ReportFilterBar (که بازه و مقایسه را دارد).
    گزینه‌ها از بک‌اند می‌آیند (report/traffic/options) تا کلیدها در دو جا تکرار
    و با گذر زمان واگرا نشوند.
  -->
  <b-card
    no-body
    class="traffic-filter mb-1"
  >
    <b-card-body class="py-1">
      <div class="d-flex align-items-center flex-wrap">
        <b-button
          size="sm"
          variant="flat-primary"
          class="px-50"
          @click="open = !open"
        >
          <feather-icon
            :icon="open ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            size="15"
          />
          <span class="ml-50">فیلتر ترافیک</span>
        </b-button>

        <b-badge
          v-if="activeCount"
          variant="light-primary"
          class="mr-50"
        >
          {{ activeCount }} فیلتر فعال
        </b-badge>

        <!-- خلاصه‌ی فیلترها وقتی بسته است، تا کاربر نداند چه چیزی پنهان مانده -->
        <div
          v-if="!open && summary.length"
          class="traffic-filter__summary mr-75"
        >
          {{ summary.join(' · ') }}
        </div>

        <div class="flex-grow-1" />

        <b-button
          v-if="activeCount"
          size="sm"
          variant="flat-secondary"
          @click="clear"
        >
          <feather-icon
            icon="XIcon"
            size="14"
          />
          <span class="ml-25">پاک کردن</span>
        </b-button>
      </div>

      <div
        v-show="open"
        class="mt-1"
      >
        <b-row>
          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">مخاطب</label>
            <b-form-select
              :value="value.Audience"
              :options="single(options.Audiences, 'همه (ربات و کاربر)')"
              size="sm"
              @change="update('Audience', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">دستگاه</label>
            <v-select
              :value="picked('Devices', options.Devices)"
              :options="options.Devices"
              label="Title"
              multiple
              dir="rtl"
              placeholder="همه"
              class="traffic-filter__select"
              @input="updateList('Devices', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">پلتفرم</label>
            <v-select
              :value="picked('Platforms', options.Platforms)"
              :options="options.Platforms"
              label="Title"
              multiple
              dir="rtl"
              placeholder="همه"
              class="traffic-filter__select"
              @input="updateList('Platforms', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">ربات</label>
            <v-select
              :value="picked('Bots', options.Bots)"
              :options="options.Bots"
              label="Title"
              multiple
              dir="rtl"
              placeholder="بی‌اهمیت"
              class="traffic-filter__select"
              @input="updateList('Bots', $event)"
            />
            <small class="traffic-filter__hint">انتخاب ربات یعنی فقط ترافیک همان ربات‌ها</small>
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">نوع آدرس</label>
            <v-select
              :value="picked('UrlKinds', options.UrlKinds)"
              :options="options.UrlKinds"
              label="Title"
              multiple
              dir="rtl"
              placeholder="همه"
              class="traffic-filter__select"
              @input="updateList('UrlKinds', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">وضعیت پاسخ</label>
            <v-select
              :value="picked('Statuses', options.Statuses)"
              :options="options.Statuses"
              label="Title"
              multiple
              taggable
              push-tags
              dir="rtl"
              placeholder="همه"
              class="traffic-filter__select"
              @input="updateList('Statuses', $event)"
            />
            <small class="traffic-filter__hint">کد دلخواه را هم می‌توانید تایپ کنید</small>
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">منبع ورودی</label>
            <b-form-select
              :value="value.ReferrerKind"
              :options="single(options.ReferrerKinds, 'همه')"
              size="sm"
              @change="update('ReferrerKind', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">جستجوی منبع</label>
            <b-form-input
              :value="value.Referrer"
              size="sm"
              placeholder="مثلاً google"
              @change="update('Referrer', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">جستجوی آدرس</label>
            <b-form-input
              :value="value.Url"
              size="sm"
              placeholder="مثلاً /product/"
              @change="update('Url', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">نوع کاربر</label>
            <b-form-select
              :value="value.UserKind"
              :options="single(options.UserKinds, 'همه')"
              size="sm"
              @change="update('UserKind', $event)"
            />
          </b-col>

          <b-col
            lg="3"
            md="6"
            cols="12"
            class="mb-75"
          >
            <label class="traffic-filter__label">کاربر</label>
            <b-form-input
              :value="value.User"
              size="sm"
              placeholder="IP یا شناسه مهمان یا شناسه کاربر"
              @change="update('User', $event)"
            />
          </b-col>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCardBody, BFormSelect, BBadge } from 'bootstrap-vue'

/** فیلترهای متنی/تک‌انتخابی و لیستی — برای شمارش و پاک‌کردن یکجا */
const TEXT_KEYS = ['Audience', 'ReferrerKind', 'Referrer', 'Url', 'UserKind', 'User']
const LIST_KEYS = ['Devices', 'Platforms', 'Bots', 'UrlKinds', 'Statuses']

export default {
  name: 'TrafficFilterBar',
  components: { BCardBody, BFormSelect, BBadge },
  props: {
    // همان data.filter صفحه (میکسین report)
    value: {
      type: Object,
      required: true,
    },
    // خروجی report/traffic/options
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      open: true,
    }
  },
  computed: {
    activeCount() {
      const lists = LIST_KEYS.filter(key => (this.value[key] || []).length).length
      const texts = TEXT_KEYS.filter(key => !!this.value[key]).length

      return lists + texts
    },

    /**
     * خلاصه‌ی خوانا برای حالت بسته. عنوان گزینه‌ها از خود بک‌اند خوانده می‌شود،
     * پس اگر گزینه‌ای اضافه شد اینجا دست‌کاری لازم نیست.
     */
    summary() {
      const parts = []

      LIST_KEYS.forEach(key => {
        const selected = this.value[key] || []

        if (selected.length) {
          parts.push(selected.map(item => this.titleOf(key, item)).join('، '))
        }
      })

      if (this.value.Audience) parts.push(this.titleOf('Audiences', this.value.Audience))
      if (this.value.ReferrerKind) parts.push(this.titleOf('ReferrerKinds', this.value.ReferrerKind))
      if (this.value.UserKind) parts.push(this.titleOf('UserKinds', this.value.UserKind))
      if (this.value.Referrer) parts.push(`منبع: ${this.value.Referrer}`)
      if (this.value.Url) parts.push(`آدرس: ${this.value.Url}`)
      if (this.value.User) parts.push(`کاربر: ${this.value.User}`)

      return parts
    },
  },
  methods: {
    titleOf(listName, key) {
      const list = this.options[listName] || []
      const found = list.find(item => item.Key === key)

      return found ? found.Title : key
    },

    /** آبجکت‌های گزینه‌ی متناظر با کلیدهای ذخیره‌شده — v-select آبجکت می‌خواهد */
    picked(key, list) {
      const keys = this.value[key] || []

      return keys.map(item => (list || []).find(option => option.Key === item) || { Key: item, Title: item })
    },

    update(key, val) {
      // رشته‌ی خالی و null یک معنا دارند؛ یکی‌شان می‌کنیم تا شمارش درست بماند
      const normalized = val === '' ? null : val

      this.$emit('input', { ...this.value, [key]: normalized })
      this.$emit('change', key)
    },

    updateList(key, selected) {
      // گزینه‌ی تایپ‌شده (taggable روی وضعیت پاسخ) کلید ندارد و vue-select آن را
      // به شکل { Title: '418' } می‌سازد، پس عنوان به‌عنوان کلید استفاده می‌شود.
      this.update(key, (selected || []).map(item => {
        if (typeof item === 'string') return item
        return item.Key || item.Title
      }))
    },

    /** گزینه‌های یک select تک‌انتخابی، با گزینه‌ی «همه» در ابتدا */
    single(list, emptyText) {
      return [
        { value: null, text: emptyText },
        ...(list || []).map(item => ({ value: item.Key, text: item.Title })),
      ]
    },

    clear() {
      const cleared = { ...this.value }

      LIST_KEYS.forEach(key => { cleared[key] = [] })
      TEXT_KEYS.forEach(key => { cleared[key] = null })

      this.$emit('input', cleared)
      this.$emit('change', 'clear')
    },
  },
}
</script>

<style lang="scss" scoped>
.traffic-filter {
  &__label {
    display: block;
    font-size: 0.75rem;
    color: #b9b9c3;
    margin-bottom: 0.25rem;
  }

  &__hint {
    display: block;
    font-size: 0.68rem;
    color: #b9b9c3;
    margin-top: 0.2rem;
  }

  &__summary {
    font-size: 0.72rem;
    color: #b9b9c3;
    max-width: 40rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // v-select پیش‌فرض بلندتر از کنترل‌های size="sm" است؛ هم‌ارتفاعشان می‌کنیم
  &__select ::v-deep .vs__dropdown-toggle {
    padding-top: 1px;
    padding-bottom: 2px;
    min-height: calc(1.5em + 0.75rem + 2px);
  }

  &__select ::v-deep .vs__selected {
    font-size: 0.75rem;
    padding: 0 0.35rem;
  }

  &__select ::v-deep .vs__search::placeholder {
    font-size: 0.8rem;
  }
}
</style>
